import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from "src/app/auth/services/authentication.service";
import { roleIdByName } from "src/app/auth/constants/auth.constants";

@Component({
  selector: "app-my-qrs-main-page",
  templateUrl: "./my-qrs-main-page.component.html",
  styleUrls: ["./my-qrs-main-page.component.css"],
})
export class MyQrsMainPageComponent implements OnInit {
  public canSeeNationalQrs: boolean = false;

  constructor(private authService: AuthenticationService) {}

  ngOnInit(): void {
    const role = this.authService.currentUserValue.fkIdRol;
    this.canSeeNationalQrs =
      role === roleIdByName.liderNacional ||
      role === roleIdByName.oficinasNacionales;
  }
}
